import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { BaseVariableListBlockComponent } from '../../../common/base-variable-list-block.component';

@Component({
    selector: 'app-meta-single-image-primary-text',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './meta-single-image-primary-text.component.html',
    styleUrl: './meta-single-image-primary-text.component.scss'
})
export class MetaSingleImagePrimaryTextComponent extends BaseVariableListBlockComponent {
  protected readonly variablePrefix = 'MetaSingleImagePrimaryText';
  protected readonly minVariables = 1;
  readonly maxVariables = 5;

  primaryTextPlaceholder = 'Enter primary text (max 150 characters)';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId);
  }

  onChange(value: any, fieldName: string): void {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent): void {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }
}
